import { useRecoilState } from 'recoil';
import { languageState } from 'state/languageState';

export const useLanguageState = (): [string, (input: string) => void] => {
  return useRecoilState(languageState);
};
